export default __webpack_public_path__ + "src/assets/quicknode.966aaf6249d58a817fcf41f6a60a6c2a.svg";